import Vue from 'vue'

export default () => {
  Vue.prototype.$shared = {}

  const getAgeLtLimit = (condition) => {
    if (typeof condition !== `string`) {
      return null
    }

    const match = condition.match(/^__age_lt__:(\d+)$/)
    if (!match) {
      return null
    }

    const limit = Number.parseInt(match[1], 10)
    return Number.isNaN(limit) ? null : limit
  }

  const getAgeInYears = (value) => {
    if (typeof value !== `string` || value.length === 0) {
      return null
    }

    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/)
    if (!match) {
      return null
    }

    const year = Number.parseInt(match[1], 10)
    const month = Number.parseInt(match[2], 10)
    const day = Number.parseInt(match[3], 10)
    const parsed = new Date(year, month - 1, day)

    if (
      parsed.getFullYear() !== year ||
      parsed.getMonth() + 1 !== month ||
      parsed.getDate() !== day
    ) {
      return null
    }

    const now = new Date()
    let age = now.getFullYear() - year
    const nowMonth = now.getMonth() + 1
    const nowDay = now.getDate()

    if (nowMonth < month || (nowMonth === month && nowDay < day)) {
      age -= 1
    }

    return age
  }

  const isAgeLtConditionSatisfied = (condition, answer) => {
    const limit = getAgeLtLimit(condition)
    if (limit === null) {
      return false
    }

    if (Array.isArray(answer)) {
      return answer.some((item) => {
        const age = getAgeInYears(item)
        return age !== null && age < limit
      })
    }

    const age = getAgeInYears(answer)
    return age !== null && age < limit
  }

  Vue.prototype.$shared.isDisplayed = function (question, answers) {
    if (!question.display || !!question?.display?.displayed) {
      return true
    }

    if (!question.display.is_displayed_if || Object.keys(question.display.is_displayed_if).length === 0) {
      return false
    }

    const compareFunc = (key) => {
      const allowedAnswers = question.display.is_displayed_if[key].answers_condition
      let chosenAnswer = answers[key]
      // if chosenAnswer is a list take the first element
      if (Array.isArray(chosenAnswer)) {
        chosenAnswer = chosenAnswer[0]
      }

      return allowedAnswers.some((condition) => {
        const isSpecialAgeCondition = getAgeLtLimit(condition) !== null
        if (isSpecialAgeCondition) {
          return isAgeLtConditionSatisfied(condition, chosenAnswer)
        }
        return condition === chosenAnswer
      })
    }

    return question?.display?.condition_type === `OR`
      ? Object.keys(question.display.is_displayed_if).some(compareFunc)
      : Object.keys(question.display.is_displayed_if).every(compareFunc)
  }
}
